import * as XLSX from "xlsx";
export function createAtamaData(atamaData, frontendChanges) {
    const excelData = [];
    if (atamaData?.gun_bazli_atamalar) {
        for (const [tarih, gunSonuc] of Object.entries(atamaData.gun_bazli_atamalar)) {
            const garajlar = gunSonuc?.garaj_atamalari || {};
            for (const garajId of Object.keys(garajlar)) {
                const garaj = garajlar[garajId];
                const soforAt = garaj?.sofor_atamalari || [];
                const aracAt = garaj?.arac_atamalari || [];
                for (const sa of soforAt) {
                    const arac = aracAt.find((a) => a.arac_blok_id === sa.arac_blok_id);
                    excelData.push({
                        Tarih: tarih,
                        Garaj: garaj?.garaj_adi || "",
                        "Şoför ID": sa.secilen_sofor_id || "",
                        "Şoför Adı": sa.secilen_sofor_adi || "",
                        "Şoför Sicil": sa.secilen_sofor_sicil || "",
                        "Araç ID": arac?.secilen_arac_id || "",
                        "Araç Plaka": arac?.secilen_arac_plaka || "",
                        "Hat No": sa.ui_hat_no || sa.hat_no || "",
                        Başlangıç: sa.ui_baslangic || "",
                        Bitiş: sa.ui_bitis || "",
                        "Süre (dk)": sa.ui_sure_dk || "",
                        "Atama Tipi": sa.atama_tipi || "",
                        Zimmet: sa.zimmet_tercihi || "",
                        Durum: "Atanmış",
                    });
                }
            }
        }
    }
    if (frontendChanges?.havuz_gorevleri) {
        for (const gorev of frontendChanges.havuz_gorevleri) {
            excelData.push({
                Tarih: gorev.tarih || "",
                Garaj: gorev.garaj_adi || "",
                "Şoför ID": gorev.sofor_id || "",
                "Şoför Adı": gorev.sofor_adi || "",
                "Şoför Sicil": gorev.sofor_sicil || "",
                "Araç ID": gorev.arac_id || "",
                "Araç Plaka": gorev.arac_plaka || "",
                "Hat No": gorev.hat_no || "",
                Başlangıç: gorev.baslangic || "",
                Bitiş: gorev.bitis || "",
                "Süre (dk)": gorev.sure_dk || "",
                "Atama Tipi": "Havuz Görevi",
                Zimmet: "Havuz",
                Durum: "Havuza Gönderildi",
            });
        }
    }
    if (frontendChanges?.gorev_degisiklikleri) {
        for (const degisiklik of frontendChanges.gorev_degisiklikleri) {
            excelData.push({
                Tarih: degisiklik.tarih || "",
                Garaj: "Değişiklik",
                "Şoför ID": "",
                "Şoför Adı": degisiklik.sofor_adi || "",
                "Şoför Sicil": "",
                "Araç ID": "",
                "Araç Plaka": "",
                "Hat No": "",
                Başlangıç: "",
                Bitiş: "",
                "Süre (dk)": "",
                "Atama Tipi": degisiklik.tip || "Görev Değişikliği",
                Zimmet: "",
                Durum: degisiklik.detay || "",
            });
        }
    }
    return excelData;
}
export function createSoforStatsData(soforStats) {
    const excelData = [];
    for (const [soforId, stats] of Object.entries(soforStats)) {
        excelData.push({
            "Şoför ID": soforId,
            "Şoför Adı": stats.sofor_adi || "",
            "Şoför Sicil": stats.sofor_sicil || "",
            "Toplam Mesai (saat)": stats.toplam_mesai_saat || 0,
            "Mesai Durumu": stats.mesai_durumu || "",
            "Ortalama Günlük Mesai": stats.ortalama_gunluk_mesai || 0,
            "En Uzun Gün": stats.en_uzun_gun || "",
            "En Kısa Gün": stats.en_kisa_gun || "",
            "Vardiya Tipi": stats.vardiya_tipi || "",
            Verimlilik: stats.verimlilik || 0,
            "İzin Günleri": stats.izin_gunleri || 0,
            Garaj: stats.garaj_adi || "",
        });
    }
    return excelData;
}
export function createGenelStatsData(genelStats) {
    return [
        { Metrik: "Toplam Şoför", Değer: genelStats.toplam_sofor || 0 },
        { Metrik: "Toplam Araç", Değer: genelStats.toplam_arac || 0 },
        {
            Metrik: "Toplam Mesai (saat)",
            Değer: genelStats.toplam_mesai_saat || 0,
        },
        {
            Metrik: "Ortalama Şoför Mesai",
            Değer: genelStats.ortalama_sofor_mesai || 0,
        },
        { Metrik: "Toplam Gün", Değer: genelStats.toplam_gun || 0 },
        {
            Metrik: "Ortalama Günlük Mesai",
            Değer: genelStats.ortalama_gunluk_mesai || 0,
        },
    ];
}
export function createUyumsuzlukData(uyumsuzlukList) {
    const excelData = [];
    for (const uyumsuzluk of uyumsuzlukList) {
        excelData.push({
            Tarih: uyumsuzluk.tarih || "",
            Garaj: uyumsuzluk.garaj_adi || "",
            "Şoför ID": uyumsuzluk.sofor_id || "",
            "Şoför Adı": uyumsuzluk.sofor_adi || "",
            "Uyumsuzluk Tipi": uyumsuzluk.uyumsuzluk_tipi || "",
            Sebep: uyumsuzluk.sebep || "",
            Öneri: uyumsuzluk.oneri || "",
        });
    }
    return excelData;
}
export async function createExcelFromData(data, parameters) {
    const workbook = XLSX.utils.book_new();
    const atamaData = createAtamaData(data.atama_sonuclari, data.frontend_changes);
    const atamaSheet = XLSX.utils.json_to_sheet(atamaData);
    XLSX.utils.book_append_sheet(workbook, atamaSheet, "Görev Atamaları");
    if (data.sofor_istatistikleri &&
        Object.keys(data.sofor_istatistikleri).length > 0) {
        const soforStatsData = createSoforStatsData(data.sofor_istatistikleri);
        const soforStatsSheet = XLSX.utils.json_to_sheet(soforStatsData);
        XLSX.utils.book_append_sheet(workbook, soforStatsSheet, "Şoför İstatistikleri");
    }
    if (data.genel_istatistikler) {
        const genelStatsData = createGenelStatsData(data.genel_istatistikler);
        const genelStatsSheet = XLSX.utils.json_to_sheet(genelStatsData);
        XLSX.utils.book_append_sheet(workbook, genelStatsSheet, "Genel İstatistikler");
    }
    if (data.uyumsuzluk_listesi && data.uyumsuzluk_listesi.length > 0) {
        const uyumsuzlukData = createUyumsuzlukData(data.uyumsuzluk_listesi);
        const uyumsuzlukSheet = XLSX.utils.json_to_sheet(uyumsuzlukData);
        XLSX.utils.book_append_sheet(workbook, uyumsuzlukSheet, "Uyumsuzluklar");
    }
    const fileName = `gorev_atama_${parameters.baslangic}_${parameters.bitis}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    return { success: true };
}
